import React from 'react';
import * as S from './Drawer.styled';
export const Drawer = ({ children }) => {
    return children;
};
const DrawerBody = ({ position, width = 320, overlay, children }) => {
    return (React.createElement(S.Drawer, null,
        React.createElement(S.Body, { key: "Drawer.Body", "$position": position, "$width": width }, children),
        overlay));
};
const DrawerOverlay = ({ onClick }) => {
    return React.createElement(S.Overlay, { onClick: onClick, key: "Drawer.Overlay", "data-testid": "Drawer.Overlay" });
};
const DrawerHeader = ({ size = 'medium', children }) => {
    return React.createElement(S.Header, { "$size": size }, children);
};
Drawer.Body = DrawerBody;
Drawer.Overlay = DrawerOverlay;
Drawer.Header = DrawerHeader;
Drawer.Navigation = S.Navigation;
Drawer.Content = S.Content;
Drawer.Section = S.Section;
Drawer.Footer = S.Footer;
